import {
  CompositeTableTemplate,
  renderCellGrayZeros,
} from 'app/common/templates-next/table-template'
import { ReportFinancesDataWriteOffCommon } from 'app/dataTypes/reports/data/common/financesSummaryWriteOff'

import { useBySchoolOrClassesTableData } from './useBySchoolOrClassesTableData'

type Props = {
  data: ReportFinancesDataWriteOffCommon
  currency: string
}

export const BySchoolOrClassesTable = ({ data, currency }: Props) => {
  const tableData = useBySchoolOrClassesTableData(data, currency)

  return (
    <CompositeTableTemplate
      data={tableData}
      renderCell={renderCellGrayZeros}
      renderFooterCell={renderCellGrayZeros}
      borderTop
    />
  )
}
